<template>
  <div style="margin-top:70px;" class="returns-page">
    <Filters />
    <TabNavigation />
    <b-row
      v-if="this.$store.getters.filterSuprazone != null && this.$store.getters.filterGroup != 0"
      class="mt-3"
    >
      <Booking :busId="busId" />
      <Bus @busIdUpdated="busId = $event" />


    </b-row>
    <b-row v-else>
      <b-col cols="12" class="mt-5">
        <div class="alert alert-danger text-center w-25">
          <i class="fa fa-fw fa-2x fa-exclamation-triangle"></i>
          <span class="text-center m-5 font-weight-bold" style="font-size: 1.2rem !important;">Por favor, seleccione datos para todos los desplegables de la parte superior de la pantalla</span>
        </div>
      </b-col>
      
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */

import Filters from "../../components/Filters/Filters";
import Booking from "../../components/Excursions/Booking/Booking";
import Bus from "../../components/Excursions/Bus/Bus";
import TabNavigation from "../../components/Common/TabNavigation";
import axios from "axios";

export default {
  components: {
    Booking,
    Bus,
    Filters,
    TabNavigation
  },
  data() {
    return {
      busId: ""
    };
  },
};
</script>